// src/pages/elibrary/LibraryList.tsx
import { useEffect, useState } from 'react';
import { collection, getDocs, deleteDoc, doc } from 'firebase/firestore';
import { fireDB } from '../../../../Backend/Firebase/FirebaseConfigData';
import { useNavigate } from 'react-router-dom';

interface LibraryEntry {
  id: string;
  title: string;
  author?: string;
  pdfUrl?: string;
  driveLink?: string;
  blogLink?: string;
  dataType?: string;
  createdAt?: { seconds: number };
}

const LibraryList = () => {
  const [entries, setEntries] = useState<LibraryEntry[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const navigate = useNavigate();

  const fetchEntries = async () => {
    setLoading(true);
    try {
      const querySnapshot = await getDocs(collection(fireDB, 'libraryEntries'));
      const fetchedEntries: LibraryEntry[] = [];
      querySnapshot.forEach((docSnap) => {
        fetchedEntries.push({ id: docSnap.id, ...docSnap.data() } as LibraryEntry);
      });
      setEntries(fetchedEntries);
    } catch (error) {
      console.error('Error fetching library entries:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id: string) => {
    if (!window.confirm('Are you sure you want to delete this entry?')) return;
    try {
      await deleteDoc(doc(fireDB, 'libraryEntries', id));
      setEntries(entries.filter((entry) => entry.id !== id));
      alert('Entry deleted successfully!');
    } catch (error) {
      console.error('Error deleting entry:', error);
    }
  };

  useEffect(() => {
    fetchEntries();
  }, []);

  if (loading)
    return (
      <div className="flex justify-center items-center h-screen">
        <p>Loading e-library entries...</p>
      </div>
    );

  return (
    <div className="min-h-screen bg-gray-50 p-6">
      <h2 className="text-3xl font-bold mb-6 text-center">📚 E-Library Entries</h2>

      <div className="overflow-x-auto bg-white shadow rounded-lg p-6">
        <table className="w-full table-auto border">
          <thead>
            <tr className="bg-gray-100">
              <th className="border p-2">Title</th>
              <th className="border p-2">Author</th>
              <th className="border p-2">Type</th>
              <th className="border p-2">Date</th>
              <th className="border p-2 text-center">Actions</th>
            </tr>
          </thead>
          <tbody>
            {entries.length === 0 ? (
              <tr>
                <td colSpan={5} className="text-center p-4 text-gray-500">
                  No entries found.
                </td>
              </tr>
            ) : (
              entries.map((entry) => (
                <tr key={entry.id} className="border-t hover:bg-gray-50">
                  <td className="p-2 border">{entry.title}</td>
                  <td className="p-2 border">{entry.author || '—'}</td>
                  <td className="p-2 border capitalize">{entry.dataType || '—'}</td>
                  <td className="p-2 border">
                    {entry.createdAt?.seconds
                      ? new Date(entry.createdAt.seconds * 1000).toLocaleDateString()
                      : '—'}
                  </td>
                  <td className="p-2 border text-center">
                    <button
                      onClick={() => navigate(`/elibrary/update/${entry.id}`)}
                      className="bg-blue-600 text-white px-3 py-1 rounded mr-2 hover:bg-blue-700 transition"
                    >
                      Edit
                    </button>
                    <button
                      onClick={() => handleDelete(entry.id)}
                      className="bg-red-600 text-white px-3 py-1 rounded hover:bg-red-700 transition"
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default LibraryList;
